import React from "react";

const statConfig = {
  earnings: {
    bg: "#61DDE9",
    label: "Monthly Earnings:",
    value: "$1234.56", // Note: This data is not in the API response
    valueClass: "bebas-bold-16",
    color: "#595959",
  },
  bookings: {
    bg: "#ff1be6",
    label: "This Months Bookings:",
    value: "15", // Will be replaced with actual data
    valueClass: "bebas-bold-16",
  },
  upcoming: {
    bg: "#a685e2",
    label: "Upcoming Bookings",
    value: "25", // Will be replaced with actual data
    valueClass: "bebas-bold-16",
  },
};

const DashboardStatBlock = ({ type, stats }) => {
  const { bg, label, valueClass, color } = statConfig[type] || {};
  
  // Get actual value from stats
  const getActualValue = () => {
    switch (type) {
      case 'bookings':
        return stats?.thisMonthsBookings?.toString() || '0';
      case 'upcoming':
        return stats?.upcomingBookings?.toString() || '0';
      case 'earnings':
        return stats?.monthlyEarnings || '$0'; // Note: This data is not in current API
      default:
        return '0';
    }
  };

  return (
    <div
      className="p-3 rounded-4 h-100 d-flex flex-column align-items-center"
      style={{ background: bg, color: color || "#fff", minHeight: 100 }}
    >
      <div
        className="lato-medium-16 text-center text-wrap"
        style={{
          whiteSpace: "normal",
          wordBreak: "break-word",
          marginBottom: 0,
        }}
      >
        {label}
      </div>
      <div className="flex-grow-1 d-flex align-items-center justify-content-center w-100">
        <div className={`${valueClass}`} style={{ fontSize: 32 }}>
          {getActualValue()}
        </div>
      </div>
    </div>
  );
};

export default DashboardStatBlock;